export const AFFILIATE_CATEGORIES = [
  {
    value: "freelance" as const,
    label: "Freelance services",
    blurb:
      "Independent specialists — grant writers, designers, developers, consultants — who plug into your team for short engagements.",
    subcategories: [
      "Grant writing",
      "Design",
      "Development",
      "Strategy & consulting",
      "Research & analysis",
      "Copywriting",
      "Project management",
    ],
  },
  {
    value: "sourcing_production" as const,
    label: "Sourcing & production",
    blurb:
      "Manufacturing, fulfillment, and supply-chain partners that help you take an idea from prototype to delivered product.",
    subcategories: [
      "Manufacturing",
      "Print & packaging",
      "Fulfillment",
      "Logistics",
      "Sourcing & procurement",
      "Quality assurance",
    ],
  },
] as const;

export type AffiliateCategory = (typeof AFFILIATE_CATEGORIES)[number]["value"];

export function categoryLabel(value: string) {
  return AFFILIATE_CATEGORIES.find((c) => c.value === value)?.label ?? value;
}